import { render } from "./BookingOverview.vue?vue&type=template&id=6cd9e83f"
import script from "./BookingOverview.vue?vue&type=script&lang=js"
export * from "./BookingOverview.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/abdom-booking/abdom-booking/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__